export const ElementType = Object.freeze({
  ANIMATION: "animation",
  IMAGE: "image",
  SHAPE: "shape",
  TEXT: "text",
  VIDEO: "video"
});
